export default __webpack_public_path__ + "assets/programsIconLine.png";